require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/imstillyourchild.com/node_modules/core-js/library/fn/object/get-prototype-of.js
// module id = 631
// module chunks = 184 185